export const GET_FILTER_SECTION = 'GET_FILTER_SECTION';
